<div class="row align-top gutters">
  <div class="col-md-4 attributes">
    <div
      [ngClass]="
        this.canEditAnAttribute()
          ? 'subsection-header-with-button'
          : 'subsection-header'
      "
      class="blue"
      >
      Attributes
      @if (this.canEditAnAttribute()) {
        <span class="save-icon">
          <button mat-mini-fab (click)="toggleAttributeEditMode()">
            @if (!attributeEditMode) {
              <mat-icon>edit</mat-icon>
            }
            @if (attributeEditMode) {
              <mat-icon>save</mat-icon>
            }
          </button>
        </span>
      }
    </div>
    <div class="mat-elevation-z8">
      @if (!attributeEditMode && !isMobile) {
        <table
          mat-table
          class="stripped-table"
          #attributeTable
          [dataSource]="attributeDataSource"
          matSort
          >
          <!-- Name Column -->
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Info</th>
            <td mat-cell class="name-column" *matCellDef="let row">
              {{ row.name }}
            </td>
          </ng-container>
          <!-- Value Column -->
          <ng-container matColumnDef="value">
            <th mat-header-cell *matHeaderCellDef>Value</th>
            <td mat-cell *matCellDef="let row">
              @if (row.value.length > 0) {
                <span>
                  @for (val of row.value; track val) {
                    <div>
                      {{ val.name }}
                    </div>
                  }
                </span>
              }
            </td>
          </ng-container>
          <tr mat-row *matRowDef="let row; columns: attributeColumns"></tr>
        </table>
      }
      @if (!attributeEditMode && isMobile) {
        <table
          mat-table
          class="stripped-table"
          #attributeTable
          [dataSource]="attributeDataSource"
          matSort
          >
          <!-- Name Column -->
          <!-- Value Column -->
          <ng-container matColumnDef="value">
            <th mat-header-cell *matHeaderCellDef>Attributes</th>
            <td mat-cell *matCellDef="let row">
              <span class="name-column">{{ row.name }}</span>
              @if (row.value.length > 0) {
                <span>
                  @for (val of row.value; track val) {
                    <div>
                      {{ val.name }}
                    </div>
                  }
                </span>
              }
              @if (row.value.length === 0) {
                <span> <div></div></span>
              }
            </td>
          </ng-container>
          <tr mat-row *matRowDef="let row; columns: thinAttributeColumns"></tr>
        </table>
      }
      @if (attributeEditMode && !isMobile) {
        <table
          mat-table
          class="stripped-table"
          #attributeTable
          [dataSource]="attributeEditData"
          matSort
          >
          <!-- Name Column -->
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Info</th>
            <td mat-cell class="name-column" *matCellDef="let row; let i = index">
              {{ row.attType.name }}
              <button
                mat-mini-fab
                (click)="addBlankAttribute(row.attType)"
                class="attribute-buttons"
                [disabled]="!row.attType?.permissions?._edit"
                >
                <mat-icon>add</mat-icon>
              </button>
              @if (row.attType.name === 'Supportive Services Included') {
                <div
                  class="supportive-services-included"
              (click)="
                addSupportiveServicesIncluded(
                  row.attType.attributes,
                  row.attType.id
                )
              "
                  >
                  Add Supportive Services Included
                </div>
              }
            </td>
          </ng-container>
          <!-- Value Column -->
          <ng-container matColumnDef="value">
            <th mat-header-cell *matHeaderCellDef>Value</th>
            <td mat-cell *matCellDef="let row">
              @if (row.data.length > 0) {
                <span>
                  @for (val of row.data; track val) {
                    <div style="display: flex">
                      <mat-select
                        [(value)]="val.attribute.name"
                        (selectionChange)="changeAttribute($event, val.attribute.id)"
                        [disabled]="!row.attType?.permissions?._edit"
                        >
                        <mat-option value=""></mat-option>
                        @for (opt of row.attType.attributes; track opt) {
                          <mat-option
                            value="{{ opt.name }}"
                            >{{ opt.name }}</mat-option
                            >
                          }
                        </mat-select>
                        <button
                          mat-mini-fab
                          (click)="removeAttribute(val.attribute)"
                          class="attribute-buttons"
                          [disabled]="!row.attType?.permissions?._edit"
                          >
                          <mat-icon>close</mat-icon>
                        </button>
                        <br />
                      </div>
                    }
                  </span>
                }
              </td>
            </ng-container>
            <tr mat-row *matRowDef="let row; columns: attributeColumns"></tr>
          </table>
        }

        @if (attributeEditMode && isMobile) {
          <table
            mat-table
            class="stripped-table"
            #attributeTable
            [dataSource]="attributeEditData"
            matSort
            >
            <!-- Name Column -->
            <!-- Value Column -->
            <ng-container matColumnDef="value">
              <th mat-header-cell *matHeaderCellDef>Value</th>
              <td mat-cell *matCellDef="let row">
                {{ row.attType.name }}
                <button
                  mat-mini-fab
                  (click)="addBlankAttribute(row.attType)"
                  class="attribute-buttons"
                  >
                  <mat-icon>add</mat-icon>
                </button>
                @if (row.data.length > 0) {
                  <span>
                    @for (val of row.data; track val) {
                      <div style="display: flex">
                        <mat-select
                          [(value)]="val.attribute.name"
                          (selectionChange)="changeAttribute($event, val.attribute.id)"
                          >
                          <mat-option value=""></mat-option>
                          @for (opt of row.attType.attributes; track opt) {
                            <mat-option
                              value="{{ opt.name }}"
                              >{{ opt.name }}</mat-option
                              >
                            }
                          </mat-select>
                          <button
                            mat-mini-fab
                            (click)="removeAttribute(val.attribute)"
                            class="attribute-buttons"
                            >
                            <mat-icon>close</mat-icon>
                          </button>
                          <br />
                        </div>
                      }
                    </span>
                  }
                  @if (row.attType.name === 'Supportive Services Included') {
                    <div
                      class="supportive-services-included"
              (click)="
                addSupportiveServicesIncluded(
                  row.attType.attributes,
                  row.attType.id
                )
              "
                      >
                      Add Supportive Services Included
                    </div>
                  }
                </td>
              </ng-container>
              <tr mat-row *matRowDef="let row; columns: thinAttributeColumns"></tr>
            </table>
          }
        </div>
      </div>
      <div class="col-md-8">
        <div class="row align-top gutters">
          <div class="col-md-6">
            <div class="subsection-header blue">KPIs</div>
            <div class="mat-elevation-z8">
              <table
                mat-table
                class="stripped-table"
                #kpiTable
                #KPISort="matSort"
                [dataSource]="KPIDataSource"
                matSort
                >
                <!-- Name Column -->
                <ng-container matColumnDef="name">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Info</th>
                  <td mat-cell class="name-column" *matCellDef="let row">
                    {{ row.name }}
                    @if (
                      row.name === 'Hard Debt' &&
                      !hasModels &&
                      permissions.loansPermissions._edit
                      ) {
                      <button
                        mat-icon-button
                  [disabled]="
                    newHardDebt.errors &&
                    newHardDebt.errors.hasOwnProperty('pattern')
                  "
                        (click)="toggleHardDebt()"
                  [ngClass]="
                    hardDebtEditMode &&
                    newHardDebt.errors &&
                    newHardDebt.errors.hasOwnProperty('pattern')
                      ? 'disabled'
                      : ''
                  "
                        >
                        @if (!hardDebtEditMode) {
                          <mat-icon>edit</mat-icon>
                        }
                        @if (hardDebtEditMode) {
                          <mat-icon>save</mat-icon>
                        }
                      </button>
                    }
                  </td>
                </ng-container>

                <!-- Value Column -->
                <ng-container matColumnDef="value">
                  <th mat-header-cell *matHeaderCellDef>Value</th>
                  <td mat-cell *matCellDef="let row">
                    @if (row.name !== 'Hard Debt') {
                      <span>{{ row.value }}</span>
                    }
                    @if (row.name === 'Hard Debt') {
                      <span>
                        @if (hasModels || !hardDebtEditMode) {
                          <span>
                            {{ row.value }}
                          </span>
                        }
                        @if (
                          !hasModels &&
                          hardDebtEditMode &&
                          permissions.loansPermissions._edit
                          ) {
                          <mat-form-field
                            class="example-full-width"
                            >
                            <mat-label>Enter Hard Debt</mat-label>
                            <input
                              matInput
                              [formControl]="newHardDebt"
                              pattern="^[0-9]*$"
                              [max]="100"
                              [min]="0"
                              />
                          </mat-form-field>
                        }
                        @if (
                          newHardDebt.errors &&
                          newHardDebt.errors.hasOwnProperty('pattern')
                          ) {
                          <small
                            class="error-text"
                            >
                            Enter a valid number for Hard Debt
                          </small>
                        }
                      </span>
                    }
                  </td>
                </ng-container>

                <tr mat-row *matRowDef="let row; columns: KPIColumns"></tr>
              </table>
            </div>
          </div>

          <div class="col-md-6">
            <div class="subsection-header blue">Census Information</div>
            <div class="mat-elevation-z8">
              <table
                mat-table
                class="stripped-table"
                #censusTable
                #censusSort="matSort"
                [dataSource]="censusDataSource"
                matSort
                >
                <!-- Census Column -->
                <ng-container matColumnDef="censusName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Info</th>
                  <td mat-cell class="name-column" *matCellDef="let row">
                    {{ row.censusName }}
                  </td>
                </ng-container>

                <!-- Value Column -->
                <ng-container matColumnDef="val">
                  <th mat-header-cell *matHeaderCellDef>Value</th>
                  <td mat-cell *matCellDef="let row">{{ row.val }}</td>
                </ng-container>

                <tr mat-row *matRowDef="let row; columns: censusColumns"></tr>
              </table>
            </div>
          </div>

          <div class="col-md-6">
            <div
          [ngClass]="
            permissions.projectDetailPermissions._edit
              ? 'subsection-header-with-button'
              : 'subsection-header'
          "
              class="blue"
              >
              @if (permissions.projectDetailPermissions._edit) {
                <span></span>
              }
              Units
              @if (permissions.projectDetailPermissions._edit) {
                <span
                  class="save-icon"
                  [ngClass]="unitsEditMode && !unitsAreValid() ? 'disabled' : ''"
                  >
                  <button
                    mat-mini-fab
                    (click)="toggleUnitsEditMode()"
                    [disabled]="unitsEditMode && !unitsAreValid()"
                    [ngClass]="unitsEditMode && !unitsAreValid() ? 'disabled' : ''"
                    >
                    @if (!unitsEditMode) {
                      <mat-icon>edit</mat-icon>
                    }
                    @if (unitsEditMode) {
                      <mat-icon>save</mat-icon>
                    }
                  </button>
                </span>
              }
            </div>
            <div class="mat-elevation-z8">
              <table
                mat-table
                class="stripped-table"
                [dataSource]="unitDataSource"
                matSort
                #unitTable
                #unitSort="matSort"
                >
                <!-- Name Column -->
                <ng-container matColumnDef="unitName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    Unit Type
                  </th>
                  <td mat-cell class="name-column" *matCellDef="let urow">
                    {{ urow.unitName }}
                  </td>
                </ng-container>

                <!-- Unit Column -->
                <ng-container matColumnDef="number">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    # of Units
                  </th>
                  <td mat-cell *matCellDef="let urow">
                    @if (
                      !unitsEditMode ||
                      !permissions.projectDetailPermissions._edit
                      ) {
                      <span
                        >{{ urow.number }}</span
                        >
                      }
                      @if (
                        unitsEditMode && permissions.projectDetailPermissions._edit
                        ) {
                        <mat-form-field
                          class="example-full-width"
                          >
                          <mat-label>Enter Units</mat-label>
                          <input
                            matInput
                            [formControl]="urow.newNumber"
                            pattern="^[0-9]*$"
                            />
                        </mat-form-field>
                      }
                      @if (urow.newNumber.errors?.pattern) {
                        <small
                          class="error-text"
                          >
                          Must type in a valid number of units
                        </small>
                      }
                    </td>
                  </ng-container>

                  <tr mat-row *matRowDef="let urow; columns: unitColumns"></tr>
                </table>
              </div>
            </div>

            <div class="col-md-6">
              <div
          [ngClass]="
            permissions.projectDetailPermissions._edit
              ? 'subsection-header-with-button'
              : 'subsection-header'
          "
                class="blue"
                >
                @if (permissions.projectDetailPermissions._edit) {
                  <span></span>
                }
                Description
                @if (permissions.projectDetailPermissions._edit) {
                  <span
                    class="save-icon"
                    >
                    <button mat-mini-fab (click)="toggleDescriptionEditMode()">
                      @if (!descriptionEditMode) {
                        <mat-icon>edit</mat-icon>
                      }
                      @if (descriptionEditMode) {
                        <mat-icon>save</mat-icon>
                      }
                    </button>
                  </span>
                }
              </div>

              @if (
                !permissions.projectDetailPermissions._edit || !descriptionEditMode
                ) {
                <div
                  >
                  @if (description) {
                    <div class="notes-read-only">
                      {{ description }}
                    </div>
                  }
                  @if (!description) {
                    <em>There is no description for this deal.</em>
                  }
                </div>
              }

              @if (
                permissions.projectDetailPermissions._edit && descriptionEditMode
                ) {
                <form
                  >
                  <mat-form-field>
                    <mat-label>Type Deal Description here</mat-label>
                    <textarea
                      matInput
                      [formControl]="desc"
                      (change)="descChanged = true"
                    ></textarea>
                  </mat-form-field>
                </form>
              }
            </div>
          </div>
        </div>
      </div>
